import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=fa927090&"
import script from "./PaymentDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports